module.exports = __webpack_public_path__ + "media/tindeck_1.6444e719.mp3";